import { create } from "zustand";

type UnreadNotificationsCountStore = {
  unreadNotificationsCount: number;
  setUnreadNotificationsCount: (count: number) => void;
  incrementUnreadNotificationsCount: (value: number) => void;
  decrementUnreadNotificationsCount: (value: number) => void;
  resetUnreadNotificationsCount: () => void;
};

export const useUnreadNotificationsCountStore = create<UnreadNotificationsCountStore>(set => ({
  unreadNotificationsCount: 0,

  setUnreadNotificationsCount: count => set({ unreadNotificationsCount: count }),

  incrementUnreadNotificationsCount: value =>
    set(state => ({
      unreadNotificationsCount: state.unreadNotificationsCount + value,
    })),

  decrementUnreadNotificationsCount: value =>
    set(state => ({
      unreadNotificationsCount: Math.max(0, state.unreadNotificationsCount - value),
    })),

  resetUnreadNotificationsCount: () => set({ unreadNotificationsCount: 0 }),
}));
